import { render } from "./TableRow.vue?vue&type=template&id=232af7d3&scoped=true&ts=true"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"

import "./TableRow.vue?vue&type=style&index=0&id=232af7d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232af7d3"]])

export default __exports__